import React from "react";
import { Row, Col, Input, Spinner } from "reactstrap";
import DateRangeSelector from "components/Common/DateRangeSelector";

const checkboxWrap = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: 10,
    background: "#3a3a3a",
    padding: "10px 14px",
    borderRadius: "12px",
    cursor: "pointer",
    border: "1px solid rgba(255,255,255,0.12)",
};

const checkboxBox = (checked) => ({
    width: 18,
    height: 18,
    borderRadius: 5,
    border: checked ? "2px solid #ffd86b" : "2px solid #888",
    background: checked ? "#ffd86b" : "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
    fontSize: 12,
    fontWeight: 700,
});

const INCLUDED_OPTIONS = [
    "corepark",
    "prospr",
    "amano",
    "spothero",
    "surepark",
    "resolve",
    "monthly_parking",
    "events",
];

const PerformanceSummaryView = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    selectedManager,
    setSelectedManager,
    selectedStructure,
    setSelectedStructure,
    included,
    toggleIncluded,
    filterBySource,
    setFilterBySource,
    loadReports,
    loading,
    accountManagers,
    progressMessages,
}) => {
    return (
        <div>
            <Row className="justify-content-center my-3">
                <Col xs="12" md="auto">
                    <DateRangeSelector
                        defaultRange={"This Month"}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        onApply={(s, e) => loadReports(s, e)}
                    />
                </Col>
                <Col xs="12" md="auto">
                    <Input
                        type="select"
                        className="form-select form-select-lg accordion-gradient-border"
                        value={selectedManager}
                        onChange={(e) => setSelectedManager(e.target.value)}
                    >
                        {accountManagers.map((m) => (
                            <option key={m} value={m}>
                                {m}
                            </option>
                        ))}
                    </Input>
                </Col>
                <Col xs="12" md="auto">
                    <Input
                        type="select"
                        className="form-select form-select-lg accordion-gradient-border"
                        value={selectedStructure}
                        onChange={(e) => setSelectedStructure(e.target.value)}
                    >
                        <option value="All Types">All Types</option>
                        <option value="Lease">Lease</option>
                        <option value="Non Lease">Non Lease</option>
                    </Input>
                </Col>

                {/* Data Sources Filter Block */}
                <Col xs="12" style={{ marginTop: 20 }}>
                    <div
                        style={{
                            background: "#2f2f2f",
                            borderRadius: 14,
                            padding: "16px 18px",
                        }}
                    >
                        <div
                            style={{
                                color: "#ffd86b",
                                fontWeight: 700,
                                marginBottom: 10,
                            }}
                        >
                            Include Data Sources
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                            {INCLUDED_OPTIONS.map((opt) => {
                                const checked = included.includes(opt);
                                return (
                                    <div
                                        key={opt}
                                        style={checkboxWrap}
                                        onClick={() => toggleIncluded(opt)}
                                    >
                                        <div style={checkboxBox(checked)}>
                                            {checked ? "✓" : ""}
                                        </div>
                                        <div
                                            style={{ color: "#fff", textTransform: "capitalize" }}
                                        >
                                            {opt.replace("_", " ")}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div
                            style={{
                                marginTop: 16,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 12,
                            }}
                        >
                            <div
                                style={checkboxWrap}
                                onClick={() => setFilterBySource(!filterBySource)}
                            >
                                <div style={checkboxBox(filterBySource)}>
                                    {filterBySource ? "✓" : ""}
                                </div>
                                <div style={{ color: "#fff", fontSize: 14 }}>
                                    Filter results for data sources
                                </div>
                            </div>
                            <button
                                onClick={() => loadReports(startDate, endDate)}
                                style={{
                                    background: "#ffd86b",
                                    color: "#000",
                                    fontWeight: 700,
                                    border: "none",
                                    borderRadius: 10,
                                    padding: "10px 18px",
                                    cursor: "pointer",
                                }}
                            >
                                Refresh
                            </button>
                        </div>
                    </div>
                </Col>
            </Row>

            {/* Loading State Display */}
            {loading && (
                <div className="d-flex justify-content-center align-items-center my-5 flex-column">
                    <Spinner
                        color="primary"
                        style={{ width: "3rem", height: "3rem" }}
                    />
                    {progressMessages.map((msg, i) => (
                        <div
                            key={i}
                            style={{ marginTop: 10, fontSize: 16, color: "#555" }}
                        >
                            {msg}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PerformanceSummaryView;